import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TABLE_SETTINGS, MESSAGES, THEME } from "../utills/constant";
import { useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { LiaTrashRestoreAltSolid } from "react-icons/lia";
import { IoTrashBinOutline } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import { GoDatabase } from "react-icons/go";import {
  GetDataCenter,
  saveDataCenter,
  getAllDataCenter,
  updateDataCenter,
  blockDataCenter,
} from "../store/actions/DataCenter";
const DataCenterLocationTab = ({ userHeader, userProducts, loading }) => {
  // redux logic
  const users = useSelector((state) => state.userManagement);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [Id, setId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = TABLE_SETTINGS.DEFAULT_PAGE_SIZE;
  const totalItems = userProducts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [formData, setFormData] = useState({
    name: "",
  });
  const toggleModal = () => {
    setEditModal(false);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    if (Id) {
      dispatch(GetDataCenter(Id));
    }
  }, [dispatch, Id]);

  const allDataCenter = useSelector((state) => state.DataCenter.servers);

  const singleDataCenter = allDataCenter.find((item) => item._id === Id);

  console.log("singleDataCenter server ", singleDataCenter);
  useEffect(() => {
    if (singleDataCenter) {
      setFormData({
        name: singleDataCenter.name || "",
      });
    }
  }, [singleDataCenter]);

  // Call APIs on mount
  useEffect(() => {
    dispatch(getAllDataCenter());
  }, [dispatch]);

  const currentItems = userProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const generatePageNumbers = () => {
    const pages = new Set();

    // Always include the first page
    pages.add(1);

    // Include "..." before middle pages if needed
    if (currentPage > 3) pages.add("...");

    // Include pages around the current page
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) {
      pages.add(i);
    }

    // Include "..." after middle pages if needed
    if (currentPage < totalPages - 2) pages.add("...");

    // Always include the last page
    if (totalPages > 1) {
      pages.add(totalPages);
    }

    return Array.from(pages);
  };

  const getDataCenterLocation = () => {
    dispatch(getAllDataCenter({}));
  };

  const handleSaveDataLocation = (e) => {
    e.preventDefault();

    const updatedData = {
      ...formData,
      id: Id, // Add the id here
    };

    console.log("Form data being sent:", updatedData);

    dispatch(updateDataCenter({ id: Id, data: { name: formData.name } }));
    toast.success("Remote type updated successfully!", {
      position: "top-right",
      autoClose: 600,
      onClose: () => {
        getDataCenterLocation(); // Refresh list
      },
    });

    // dispatch(updateServiceType(updatedData)).then(() => {
    //   toast.success("Server type updated successfully!", {
    //     position: "top-right",
    //     autoClose: 600,
    //     onClose: () => {
    //       getServerType(); // Refresh list
    //     },
    //   });
    // });

    // Clear form and close modal

    setFormData({
      name: "",
      status: "1",
      id: -1,
    });
    setEditModal(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const BlockDataCenter = (id) => {
    const updatedData = {
      id: id,
    };

    console.log("Form data being sent:", id);

    dispatch(blockDataCenter({ id: id })).then(() => {
      toast.success("data center location block successfully!", {
        position: "top-right",
        autoClose: 600,
        onClose: () => {
          getDataCenterLocation(); // Refresh list
        },
      });
    });
  };

  const handleUnblockBlockDatacenter = (id) => {
    dispatch(updateDataCenter({ id: id, data: { status: 1 } }));
    toast.success("Unblock data center location successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        getDataCenterLocation();
      },
    });
  };

  const paginationNumbers = generatePageNumbers();

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-2">
      {loading ? (
        <div className="text-center text-gray-500">{MESSAGES.LOADING}</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">{MESSAGES.NO_DATA}</div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left rtl:text-right bg-card  text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-text uppercase bg-cardG !bg-[#02256d] text-white">
                <tr>
                  <th scope="col" className="p-4">
                    <div className="flex items-center">
                      <input
                        id="checkbox-all-search"
                        type="checkbox"
                        className="w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                        aria-label="Select all products"
                      />
                    </div>
                  </th>
                  {userHeader.map((header, index) => (
                    <th key={index} scope="col" className="px-6 py-3">
                      {header.label || header.key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((product, index) => (
                  <tr
                    key={index}
                    className="bg-card border-b  dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    <td className="w-4 p-4">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-[#02256d] bg-gray-100 border-gray-300 rounded focus:ring-blue-50 dark:focus:ring-[#02256d] dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          aria-label={`Select product ${product.name}`}
                        />
                      </div>
                    </td>
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium  whitespace-nowrap "
                    >
                      {product.name}
                    </th>
                    <td className="px-6 py-4">{product.email}</td>
                    <td className="px-6 py-4">{product.phone}</td>
                    <td className="px-6 py-4">{product.roleId}</td>
                    <td className="px-6 py-4">{product.status}</td>
                    <td className="px-6 py-4 gap-4 flex">
                      <a
                        href="#"
                        title="Edit"
                        className="font-medium text-blue-600  border  border-blue-600  px-2 py-1 rounded-lg hover:text-white hover:bg-blue-600"
                        onClick={() => {
                          setEditModal(true);
                          setId(product._id);
                        }}
                      >
                        <MdEdit className="text-lg" />
                      </a>
                      <a
                        href="#"
                        title="Data"
                        className="font-medium text-green-600  border  border-green-600  px-2 py-1 rounded-lg hover:text-white hover:bg-green-600"
                      >
                        <GoDatabase className="text-lg" />
                      </a>
                      {product?.status == "1" && (
                        <button
                          className="font-medium text-red-600  border  border-red-600  px-2 rounded-lg hover:text-white hover:bg-red-600"
                          onClick={() => BlockDataCenter(product._id)}
                          title="Block"
                        >
                          <IoTrashBinOutline className="text-lg" />
                        </button>
                      )}
                      {product?.status == "0" && (
                        <button
                          onClick={() =>
                            handleUnblockBlockDatacenter(product?._id)
                          }
                          title="Unblock"
                          className="font-medium text-green-600  border  border-green-600  px-2 rounded-lg hover:text-white hover:bg-green-600"
                        >
                          <LiaTrashRestoreAltSolid className="text-lg" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {editModal && (
              <div className="fixed inset-0 mt-4 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
                <div className="relative p-4 w-full max-w-md h-auto overflow-hidden">
                  <div className="relative bg-card rounded-lg shadow max-h-[90vh] overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                      <h3 className="text-lg font-semibold text-text">
                        Add New Data Location
                      </h3>
                      <button
                        type="button"
                        className="text-text bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600"
                        onClick={toggleModal}
                      >
                        <IoClose className="w-5 h-5" />
                      </button>
                    </div>

                    {/* Modal Body */}
                    <form
                      className="p-4 md:p-5"
                      onSubmit={handleSaveDataLocation}
                    >
                      <div className="grid gap-4 mb-4 grid-cols-1">
                        <div>
                          <label
                            htmlFor="name"
                            className="block mb-2 text-sm font-medium text-text"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            placeholder="Enter location"
                            required
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="w-full justify-center text-white inline-flex items-center bg-[#02256d] hover:bg-blue-950 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}
            <nav
              className="flex items-center justify-between m-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-black">
                Showing{" "}
                <span className="font-semibold text-text">
                  {(currentPage - 1) * itemsPerPage + 1} -{" "}
                  {Math.min(currentPage * itemsPerPage, totalItems)}
                </span>{" "}
                of <span className="font-semibold text-text">{totalItems}</span>
              </span>
              <ul className="inline-flex -space-x-px text-sm h-8">
                {/* Previous Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100"
                  >
                    Previous
                  </button>
                </li>

                {/* Page Numbers */}
                {paginationNumbers.map((page, index) => (
                  <li key={index}>
                    {page === "..." ? (
                      <span className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300">
                        ...
                      </span>
                    ) : (
                      <button
                        onClick={() => handlePageChange(page)}
                        className={`flex items-center justify-center px-3 h-8 ${
                          currentPage === page
                            ? "text-white bg-[#02256d]"
                            : "text-gray-500 bg-white"
                        } border border-gray-300 `}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}

                {/* Next Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100"
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  );
};

export default DataCenterLocationTab;
